/* eslint-disable @typescript-eslint/no-non-null-assertion */
import {useQuery} from '@tanstack/react-query'

import {getProducts, getProductById} from './api'
import {productKeys} from './keys'
import {ProductResponse} from './types'

export const useProducts = () => {
  return useQuery<ProductResponse[], unknown>({
    queryKey: productKeys.lists(),
    queryFn: getProducts,
  })
}

export const useProduct = (id?: string) => {
  return useQuery<ProductResponse, unknown>({
    queryKey: productKeys.detail(id || ''),
    queryFn: () => getProductById(id!),
    enabled: !!id,
  })
}
